export default __webpack_public_path__ + "static/media/home_hero.df86334b.jpg";